import * as React from "react";
import styled from "styled-components";
import { Container, Label, InputContainerStates } from "../InputContainer";
import { select } from "@hubper/theme";

const Base = styled(Container)`
  height: auto;
  padding: ${select.space(2)} ${select.space(3)};
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  stretch?: boolean;
  children: any;
  onClick?: (evt: any) => void;
  label?: string;
} & InputContainerStates;

function EditorWrapper(
  {
    style,
    className,
    stretch,
    children,
    label,
    error,
    disabled,
    focus,
    onClick
  }: Props,
  ref: any
) {
  const labelColorType = error ? "error" : "grey";
  const labelColorIndex = focus ? 6 : 4;

  return (
    <Base
      ref={ref}
      stretch={stretch}
      focus={focus}
      disabled={disabled}
      error={error}
      style={style}
      className={className}
    >
      {children}
      {label && (
        <Label c={[labelColorType, labelColorIndex]} fs={-2} onClick={onClick}>
          {label}
        </Label>
      )}
    </Base>
  );
}

export default React.forwardRef(EditorWrapper);
